import { AbstractControl } from '@angular/forms';

export function swiftCodeValidator(swiftKey = 'swiftCode') {
    return (frm: AbstractControl) => {
        return !frm.get(swiftKey).value || frm.get(swiftKey).value.length === 8 || frm.get(swiftKey).value.length === 11
            ? null
            : {
                swiftCodeError: true
            };
    };
}
